import actions from '../../actionTypes';

export default zone => {
  return {
    type: actions.DELETE_ZONE,
    zone
  };
};



// WEBPACK FOOTER //
// ./src/reducers/zones/actions/deleteZone.js